// Layout.jsx
import { DashboardLayout, ToolbarActions } from '@toolpad/core/DashboardLayout'
import Stack from '@mui/material/Stack'
import { Outlet, useLocation } from 'react-router-dom'
import OrganizationSwitcher from '../components/organization/OrganizationSwitcher'

function ReldoToolbarActions() {
	return (
		<Stack direction='row' alignItems='center' spacing={1}>
			<OrganizationSwitcher />
			<ToolbarActions />
		</Stack>
	)
}

function Layout() {
	const location = useLocation()

	// Маршруты, где Sidebar (DashboardLayout) не должен отображаться
	const noSidebarRoutes = ['/login']
	const isSidebarHidden = noSidebarRoutes.includes(location.pathname)

	if (isSidebarHidden) {
		// Если Sidebar не нужен, рендерим только дочерние элементы
		return <Outlet />
	}

	return (
		<DashboardLayout sidebarExpandedWidth={272} slots={{ toolbarActions: ReldoToolbarActions }}>
			<Outlet />
		</DashboardLayout>
	)
}

export default Layout
